<template v-loading="loading">
  <el-container>
    <el-header>
      新增经销商
      <el-divider></el-divider>
    </el-header>
    <el-main>
      <div class="form-main">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" :label-position="labelPosition">
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请填写公司全称"></el-input>
          </el-form-item>
          <el-form-item label="所属大区" prop="belongArea">
            <el-input v-model="form.belongArea" placeholder="请填写公司所属大区"></el-input>
          </el-form-item>
          <el-form-item label="负责区域" prop="responsibleArea">
            <el-input v-model="form.responsibleArea" placeholder="请填写负责区域"></el-input>
          </el-form-item>
          <el-form-item label="联系人1" prop="contacts1">
            <el-input v-model="form.contacts1" placeholder="如 张三  123133"></el-input>
          </el-form-item>
          <el-form-item label="联系人2" prop="contacts2">
            <el-input v-model="form.contacts2" placeholder="如 张三  123133"></el-input>
          </el-form-item>
          <el-form-item label="公司电话" prop="companyPhone">
            <el-input v-model="form.companyPhone" placeholder="请输入公司电话"></el-input>
          </el-form-item>
          <el-form-item label="公司地址" prop="companyAddress">
            <el-input v-model="form.companyAddress" placeholder="请填写公司地址"></el-input>
          </el-form-item>
          <el-form-item label="经营范围" prop="businessScope">
            <el-input v-model="form.businessScope" placeholder="请填写公司经营范围"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="onSubmit('form')">提交</el-button>
            <el-button size="medium" @click="onBack">返回</el-button>
          </el-form-item>
        </el-form>
      </div>

    </el-main>
  </el-container>

</template>

<script>
  export default {
    name: "AddDealer",
    data() {
      return {
        labelPosition:'right',
        form: {},
        rules: {
          companyName: [
            {required: true, message: '请输入公司名称', trigger: 'blur'},
          ],
          belongArea: [
            {required: true, message: '请输入公司所属大区', trigger: 'blur'},
          ],
          responsibleArea: [
            {required: true, message: '请输入负责区域', trigger: 'blur'},
          ],
          contacts1: [
            {required: true, message: '请输入联系人', trigger: 'blur'},
          ],
          companyPhone: [
            {required: true, message: '请输入公司电话', trigger: 'blur'},
          ],
          companyAddress: [
            {required: true, message: '请输入公司地址', trigger: 'blur'},
          ],
          username: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
          ],
        },
        loading: false
      }
    },
    methods: {
      onSubmit(form) {
        this.loading = true
        this.$refs[form].validate((valid) => {
          if (valid) {
            this.$http.post("https://yuanteng.tech:8081/dealer/save", this.form).then(res => {
              if (res.data.status) {
                this.$message({
                  message: res.data.msg,
                  type: 'success'
                });
                this.form = {};
              } else {
                this.$message.error(res.data.msg);
              }
            }).finally(() => {
              this.loading = false
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      onBack() {
        this.$router.push('/index/dealer');
      },
      handleResize(){
        if(window.innerWidth < 456){
          this.labelPosition = "top";
        }else {
          this.labelPosition = "right";
        }
      }
    },
    created() {
      var user = JSON.parse(window.localStorage.getItem('access-admin'));
      this.handleResize();
      window.addEventListener('resize',this.handleResize);
    },
    beforeDestroy() {
      window.removeEventListener('resize',this.handleResize);
    }
  }
</script>

<style scoped>
  .el-form {
    width: 100%;
  }

  .el-main {
    display: flex;
  }

  .el-divider--horizontal {
    width: 100px;
    margin: 10px 0;
  }

  .el-divider {
    background-color: #257ac7;
  }
  @media screen {
    /deep/ .el-form--label-top .el-form-item__label{
      padding: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AddDealer.vue